import axios from "../../app/common/libs/http";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchTranscripts = createAsyncThunk(
  "transcripts/getTranscripts",
  async (payload) =>
    await axios.post(
      `${process.env.REACT_APP_APIURL}/insights/getTranscripts`,
      payload
    )
);
export const fetchConversationBySid = createAsyncThunk(
    "transcripts/getConversationBySid", async (data) => await axios.post(`${process.env.REACT_APP_APIURL}/conversation/getConversationAndCustomerProfileBySid`, data)
);
export const fetchConversationMessages = createAsyncThunk(
  "transcripts/getConversationMessages", async (data) => await axios.post(`${process.env.REACT_APP_APIURL}/message/getMessages`, data)
);
export const fetchConversationRating = createAsyncThunk(
  "transcripts/getConversationRating", async (conversationSid) => await axios.get(`${process.env.REACT_APP_APIURL}/conversation/getRating/${conversationSid}`, { conversationSid: conversationSid})
);
export const fetchTranscriptByConversationId = createAsyncThunk(
  'transcripts/getTranscript',
  async (conversationId) =>
    await axios.post(`${process.env.REACT_APP_APIURL}/insights/getTranscript`, {
      conversationId: conversationId,
    })
);
export const sendCurrentTranscriptHistory = createAsyncThunk(
  'transcripts/sendCurrentTranscriptHistory',
  async (data) =>
    await axios.post(`${process.env.REACT_APP_APIURL}/conversation/sendTranscript`, data)
);
export const sendAllTranscriptHistory = createAsyncThunk(
  'transcripts/sendAllTranscriptHistory',
  async (data) =>
    await axios.post(`${process.env.REACT_APP_APIURL}/conversation/sendTranscriptHistoryOnEmail`, data)
);

export const updateCustomerInfo = createAsyncThunk(
  'transcripts/updateCustomerInfo',
  async (data) =>
    await axios.post(`${process.env.REACT_APP_APIURL}/conversation/updateCustomerInfo`, data)
);
